"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentSection = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
const component_styles_1 = require("@/components/domains/component/component.styles");
let ComponentSection = class ComponentSection extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = '';
        this.description = '';
        this.code = '';
        this.width = '';
        this.fullWidth = false;
    }
    render() {
        return (0, lit_1.html) `
      <mm-text-block
        level="2"
        heading=${this.heading}
        description=${this.description}
      ></mm-text-block>
      <slot name="notice"></slot>
      <div class="example">
        ${this.renderCode()}
        <div class="component-content-frame">
          <slot></slot>
        </div>
      </div>
    `;
    }
    renderCode() {
        if (!this.code)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <div class="component-content-frame">
        <mm-code-block variant="plain" .code=${this.code}></mm-code-block>
      </div>
    `;
    }
};
ComponentSection.styles = [
    component_styles_1.componentExampleStyles,
    (0, lit_1.css) `
      :host {
        display: flex;
        flex-direction: column;
        gap: var(--space-6);
        margin-top: var(--space-section);
      }

      /* 코드와 전시는 같은 예시의 두 면이라 설명과 떨어진 간격보다 좁게 붙인다. */
      .example {
        display: flex;
        flex-direction: column;
        gap: var(--space-4);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ComponentSection.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ComponentSection.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ComponentSection.prototype, "code", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], ComponentSection.prototype, "width", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, attribute: 'full-width', reflect: true })
], ComponentSection.prototype, "fullWidth", void 0);
ComponentSection = __decorate([
    (0, decorators_js_1.customElement)('mm-component-section')
], ComponentSection);
exports.ComponentSection = ComponentSection;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LXNlY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb21wb25lbnQtc2VjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBb0Q7QUFDcEQscURBQTJEO0FBRTNELCtCQUE0QjtBQUU1QixzRkFBd0Y7QUFHakYsSUFBTSxnQkFBZ0IsR0FBdEIsTUFBTSxnQkFBaUIsU0FBUSxnQkFBVTtJQUF6Qzs7UUFtQnVCLFlBQU8sR0FBRyxFQUFFLENBQUE7UUFDWixnQkFBVyxHQUFHLEVBQUUsQ0FBQTtRQUNoQixTQUFJLEdBQUcsRUFBRSxDQUFBO1FBQ00sVUFBSyxHQUFrQixFQUFFLENBQUE7UUFDQyxjQUFTLEdBQUcsS0FBSyxDQUFBO0lBNEJ4RixDQUFDO0lBMUJDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7a0JBR0csSUFBSSxDQUFDLE9BQU87c0JBQ1IsSUFBSSxDQUFDLFdBQVc7Ozs7VUFJNUIsSUFBSSxDQUFDLFVBQVUsRUFBRTs7Ozs7S0FLdEIsQ0FBQTtJQUNILENBQUM7SUFFTyxVQUFVO1FBQ2hCLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSTtZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRTlCLE9BQU8sSUFBQSxVQUFJLEVBQUE7OytDQUVnQyxJQUFJLENBQUMsSUFBSTs7S0FFbkQsQ0FBQTtJQUNILENBQUM7O0FBakRNLHVCQUFNLEdBQUc7SUFDZCx5Q0FBc0I7SUFDdEIsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7O0tBY0Y7Q0FDRixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztpREFBYTtBQUNaO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztxREFBaUI7QUFDaEI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzhDQUFVO0FBQ007SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7K0NBQTBCO0FBQ0M7SUFBcEUsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxTQUFTLEVBQUUsWUFBWSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzttREFBa0I7QUF2QjNFLGdCQUFnQjtJQUQ1QixJQUFBLDZCQUFhLEVBQUMsc0JBQXNCLENBQUM7R0FDekIsZ0JBQWdCLENBbUQ1QjtBQW5EWSw0Q0FBZ0IifQ==